if (!customElements.get('deferred-media')) {
  customElements.define(
    'deferred-media',
    class DeferredMedia extends HTMLElement {
      constructor() {
        super();
        const poster = this.querySelector('[id^="Deferred-Poster-"]');
        if (!poster) return;
        poster.addEventListener('click', this.loadContent.bind(this));
      }

      loadContent(focus = true) {
        if (this.getAttribute('loaded')) return;

        const template = this.querySelector('template');
        if (!template) return;

        // 直接用 innerHTML 展开 template，避免 cloneNode 问题
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = template.innerHTML;
        const mediaEl = tempDiv.firstElementChild;
        if (!mediaEl) return;

        this.setAttribute('loaded', true);
        this.appendChild(mediaEl);

        if (focus) mediaEl.focus();

        if (mediaEl.nodeName === 'VIDEO') {
          mediaEl.play().catch(() => {});
        }
      }
    }
  );
}
